// Lo adjuntado a una edición con prompt (productos, modelos, subidas) como las
// `reference_images` del body de `/v1/images/edit`, con la mención con que se los nombra.
// Lo comparten la barra de Editar del visor y la pantalla de Editar
// (ADR-2026-10-06-editar-con-referencias-y-escritor, ADR-2026-10-07-la-pantalla-de-editar-adjunta-y-escribe).

import { useCallback } from 'react';
import type { ChatAttachment } from '../pages/v2/agentAttachments';
import { signReferenceImage } from '../pages/v2/agentAttachments';
import { getProductFullImageUrl } from '../pages/v2/productsApi';
import { useUserModels } from '../pages/v2/modelsContext';
import { conMenciones } from '../pages/v2/mencionesDeAdjuntos';
import { resolverReferencias } from '../pages/v2/modes/promptLibre/promptLibre';

/** Lo que el body de la edición espera de cada referencia. */
export type ReferenciaDelBody = { url?: string; tipo: string; product_id?: string; etiqueta?: string; mencion?: string };

export function useReferenciasDeEdicion() {
  const userModels = useUserModels();
  return useCallback(
    async (lista: ChatAttachment[], company: string): Promise<ReferenciaDelBody[]> => {
      if (lista.length === 0) return [];
      const refs = conMenciones(
        await resolverReferencias(lista, {
          productoUrl: (id) => getProductFullImageUrl(company, id),
          modeloUrl: (id) => userModels.find((m) => String(m.id) === id)?.thumbnailUrl ?? null,
          adjuntoUrl: (path, bucket) => signReferenceImage(path, bucket),
        }),
        lista,
      );
      return refs.map((r) => ({
        ...(r.url ? { url: r.url } : {}),
        tipo: r.tipo,
        ...(r.productId ? { product_id: r.productId } : {}),
        ...(r.etiqueta ? { etiqueta: r.etiqueta } : {}),
        ...(r.mencion ? { mencion: r.mencion } : {}),
      }));
    },
    [userModels],
  );
}
